"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var Row = function Row(_ref) {
  var _classNames;

  var children = _ref.children,
      className = _ref.className,
      align = _ref.align,
      reverse = _ref.reverse;
  var classes = (0, _classnames.default)('ui-row', className, (_classNames = {}, (0, _defineProperty2.default)(_classNames, "ui-row--align-".concat(align), align), (0, _defineProperty2.default)(_classNames, 'ui-row--reverse', reverse), _classNames));
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes
  }, children);
};

Row.defaultProps = {
  className: ''
};
Row.propTypes = {
  /** Aligns Row "right" or "center" based on the given value. */
  align: _propTypes.default.string,

  /** Child content rendered inside Row. */
  children: _propTypes.default.node,

  /** Custom class name added to Row. */
  className: _propTypes.default.string,

  /** Reverses the ordering of Cols in Row. */
  reverse: _propTypes.default.bool
};
var _default = Row;
exports.default = _default;
//# sourceMappingURL=Row.js.map